module.exports = "/images/Homepage-What We Do.jpg";